import React, { useState, useEffect, useContext, useRef } from 'react';
import html2canvas from 'html2canvas'; // Import the rendering library
import jsPDF from 'jspdf';           // Import the PDF generating library
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm , useFieldArray } from 'react-hook-form';
import { Layout } from '../../../../components';
import AppContext from '../../../../contexts/AppContext';
import { handleApi, formatCurrency, formatTwoDecimal, formatMediumDate, capitalize, AudioSpinner,useToast } from '../../../../utils/utils';



// Approve component for the filterable product input

const ProductSearchInput = ({ products, onSelectProduct, selectedProduct }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  // Add a safeguard to ensure 'products' is a valid array before filtering
  const filteredProducts = (Array.isArray(products) ? products : []).filter(product => {
    if (!product || typeof product.label !== 'string') {
      return false; // Skip any non-valid product objects
    }
    return product.label.toLowerCase().includes(searchTerm.toLowerCase());
  });
  

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  // FINAL FIX: Add a check to ensure selectedProduct is a valid object before trying to access its properties.
  useEffect(() => {
    if (selectedProduct && typeof selectedProduct.product_name === 'string') {
      setSearchTerm(selectedProduct.product_name);
    } else {
      setSearchTerm('');
    }
  }, [selectedProduct]);

  return (
    <div className="relative w-full" ref={wrapperRef}>
      <input
        type="text"
        className="w-full bg-gray-500 text-white border-b-2 focus:outline-none focus:border-cyan-300 border-cyan-200 rounded-md p-1 pl-2"
        placeholder="Search product..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={() => setShowDropdown(true)}
      />
      {showDropdown && (
        <ul className="absolute z-10 w-full mt-1 bg-gray-700 rounded-md shadow-lg max-h-48 overflow-y-auto">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <li
                key={product.value}
                className="p-2 text-white hover:bg-cyan-200 hover:text-gray-800 cursor-pointer"
                onClick={() => {
                  onSelectProduct(product);
                  setSearchTerm(product.label);
                  setShowDropdown(false);
                }}
              >
                {product.label}
              </li>
            ))
          ) : (
            <li className="p-2 text-gray-400">No products found.</li>
          )}
        </ul>
      )}
    </div>
  );
};


// Icons for the buttons (using simple inline SVG for elegance and no extra dependencies)
const DownloadIcon = (props) => (
  <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const PrintIcon = (props) => (
  <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m0 0v2a2 2 0 002 2h4a2 2 0 002-2v-2M9 17h6" />
  </svg>
);

const EmailIcon = (props) => (
  <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

// You would typically export the main component for use in the parent file
// export default PrintableQuotation; 
const getStatusStyles = (status) => {
  let text = status || 'Draft';
  let pillClasses = 'bg-gray-200 text-gray-700';
  return { text, pillClasses };
};

const ApproveQuotation = () => {
  const location = useLocation()
  const navigate = useNavigate();
  const { initialQuotation } = location.state || {};
  console.log('intial qoue',initialQuotation)
  
//   const [quotation, setQuotation] = useState(initialFormState);

  const [transactionLines, setTransactionLines] = useState([]);
  //  Use local state for quotation, initialized with initialQuotation
  const [quotation, setQuotation] = useState(initialQuotation || {}); 
  const [products, setProducts] = useState([]);
  const [formattedProducts, setFormattedProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [formattedCustomers, setFormattedCustomers] = useState([]);
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null); //state to hold customer details
  const { userData, currentColor, actionCount,setActionCount} = useContext(AppContext);

  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false); // NEW STATE
  const { showToast, toastMessage } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false); // State for the reset confirmation modal
  const [focusedIndex, setFocusedIndex] = useState(null);
  // const quotationRef = useRef(null); // Ref to the quotation content for PDF generation
  const quantityRefs = useRef([]);    // a ref for each quantity input field to manage focus


  // const handleAction = (action) => {
  //   if (action === 'download') {
  //     showToast(`Simulated action: ${action}`, 'success');
  //   } else if (action === 'print') {window.print();
  //   } else {showToast(`Simulated action: ${action}`, 'success');}
  // };

  const TransactionLineHeader = () => {
    return (
      <div className="grid grid-cols-6 gap-2 p-2 border-b rounded-lg bg-gray-100 text-gray-800 font-semibold text-xs md:text-xs">
        <div className="col-span-2 text-left">Product Description</div>
        <div className="col-span-1 text-center">Price</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1 text-center">Disc %</div>
        <div className="col-span-1 text-right">Total</div>
      </div>
    );
  };

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return {
          text: 'APPROVED',
          pillClasses: 'bg-emerald-700/50 text-emerald-300 ring-emerald-500/30',
        };
      case 'invoiced':
        return {
          text: 'INVOICED',
          pillClasses: 'bg-violet-700/50 text-violet-300 ring-violet-500/30',
        };
      case 'draft':
        return {
          text: 'DRAFT',
          pillClasses: 'bg-slate-700/50 text-slate-300 ring-slate-500/30',
        };
      case 'cancelled':
        return {
          text: 'CANCELLED',
          pillClasses: 'bg-rose-700/50 text-rose-300 ring-rose-500/30',
        };
      default:
        return {
          text: status?.toUpperCase() || 'UNKNOWN',
          pillClasses: 'bg-gray-700/50 text-gray-400 ring-gray-500/30',
        };
    }
  };
  
  // ... inside your component
  // ⭐ CHANGE 2: Read status from the local 'quotation' state
  const status = quotation?.state; 
  const { text, pillClasses } = getStatusStyles(status);
 
  // Inside the ApproveQuotation component...

const quotationRef = useRef(null); // Ref to the quotation content for PDF generation
// ... (other state/refs)




const handleSubmit = async () => {
    setIsLoading(true);
    console.log('quotation sir ',quotation)

    try {
      // The API call to update the state
      const response = await handleApi('sales/orders', {  id:quotation.id,state: 'approved'}, userData, 'PUT');
      if (response.status === 200) {
        // ⭐ CRITICAL CHANGE 3: Update local state upon successful approval
        setQuotation(prevQuotation => ({ ...prevQuotation, state: 'approved' })); 
        showToast(response.data.message || 'Quotation approved successfully!', 'success');
      } else {
        showToast(response.data.message || 'Error approving quotation!', 'error');
      }
    } catch (error) {
      showToast(error.message || 'Error approving quotation!', 'error');
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };
   return (
    <Layout>
      

      <div className="min-h-screen text-white p-2 sm:p-4">
        {/* Toast Message Display */}
        {toastMessage.show && (
          <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-lg shadow-md z-50
            ${toastMessage.type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
            {toastMessage.message}
          </div>
        )}
        
        {/* Header and Back Button */}
        <div className="relative flex justify-between items-center mb-4">
        <h1 className="font-extrabold text-gray-800 tracking-wide flex-grow text-center text-xl sm:text-2xl">
  {
    // Check if the reference exists (is truthy)
    initialQuotation.reference
      ? 'APPROVE SALES ORDER'  // If YES (reference is available)
      : 'APPROVE QUOTATION'    // If NO (reference is not available)
  }
</h1>
{/* Action Button Group (NEW) */}
<div className="flex gap-1 sm:gap-2 mr-12"> 
             <button
               onClick={handleSubmit}
              className="p-2 rounded-full text-cyan-300 bg-gray-700/50 hover:bg-cyan-500 hover:text-gray-900 transition-all duration-300 shadow-md border border-cyan-500/50"
              aria-label="Approve Quotation"
              title="Approve"
               // Conditionally disable the button if it's already approved
              disabled={quotation?.state?.toLowerCase() === 'approved' || isLoading}
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>
           
          </div>


          <div className="flex gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-2 rounded-full text-gray-800 bg-white hover:bg-gray-300 transition-all duration-300 shadow-md"
              aria-label="Go back"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </button>
          </div>
        </div>

            {/* Main Content Area */}
            <div 
          className="bg-gray-800/90 backdrop-blur-sm rounded-3xl border border-cyan-700/50 shadow-2xl p-4 sm:p-6 mx-auto max-w-4xl"
          ref={quotationRef} // <--- THIS IS THE MISSING PIECE!
        > 
          {isLoading ? (
            <div className="flex flex-col items-center py-10">
              <AudioSpinner />
              <p className="mt-4 text-cyan-300 text-base">Approving. Please wait...</p>
            </div>
          ) : (
            <div className="space-y-8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                
                {/* Customer Info Card - Approve Only */}
                <div className="bg-gray-700/70 border border-cyan-500/30 p-4 rounded-xl shadow-lg">
                  <p className="font-extrabold text-cyan-200 text-center mb-3 uppercase text-lg border-b border-cyan-500/50 pb-2">Customer Details</p>
                  <div className="flex flex-col gap-3 text-sm">
                    {/* Customer Name (Replaces Select Field) */}
                    <div className="flex flex-col">
                      <label className="font-medium text-cyan-300 mb-1">Customer Name</label>
                      <div className="w-full bg-gray-700 text-white font-bold border-b border-cyan-400 py-1 px-1">
                        {quotation?.partners?.name || 'N/A'}
                      </div>
                    </div>

                
                      <>
                        <div className="flex justify-between items-center">
                          <label className="font-medium text-cyan-300">Telephone</label>
                          <span className="text-white font-medium text-right">{quotation?.partners?.phone_number || 'NA'}</span>
                        </div>
                        
                        <div className="flex justify-between items-center">
                          <label className="font-medium text-cyan-300">Contact Person</label>
                          <span className="text-white font-medium text-right">{quotation?.partners?.contact_person || 'NA'}</span>
                        </div>

                        <div className="flex justify-between items-center">
                          <label className="font-medium text-cyan-300">Email Address</label>
                          <span className="text-white font-medium text-right">{quotation?.partners?.email || 'NA'}</span>
                        </div>
                      </>
                  
                  </div>
                </div>

                {/* Quotation Info Card - Approve Only */}
                <div className="bg-gray-700/70 border border-cyan-500/30 p-4 rounded-xl shadow-lg">
                <p className="font-extrabold text-cyan-200 text-center mb-3 uppercase text-lg border-b border-cyan-500/50 pb-2">
  {
    // Check if the reference exists (is truthy)
    quotation.reference
      ? 'Sales Order Details'  // If YES (reference is available)
      : 'Quotation Details'    // If NO (reference is not available)
  }
</p>
                  <div className="flex flex-col gap-3 text-sm">
                    {/* Description (Replaces Textarea) */}
                    {quotation.description ? (
  // If description exists, show the description
  <p className="w-full bg-gray-700 text-white border-b border-cyan-400 p-1 min-h-[40px] whitespace-pre-wrap">
    {quotation.description}
  </p>
) : (
  // Otherwise, show the placeholder
  <div className="w-full bg-gray-700 text-white border-b border-cyan-400 p-1 min-h-[40px] whitespace-pre-wrap">
    {'No description provided.'}
  </div>
)}
                    
                    <div className="flex justify-between items-center">
                          <label className="font-medium text-cyan-300">Reference</label>
                          <span className="text-white font-medium text-right">{quotation?.reference || quotation?.id || 'NA'}</span>
                        </div>
                        
                        <div className="flex justify-between items-center">
                          <label className="font-medium text-cyan-300">Date</label>
                          <span className="text-white font-medium text-right">{formatMediumDate(quotation?.date) || 'NA'}</span>
                        </div>

                        <div className="flex justify-between items-center py-2 border-b border-gray-700/50">
  <label className="font-light text-sm tracking-wider text-cyan-300 uppercase">
    Status
  </label>
  
  <span 
    className={`
      inline-flex 
      items-center 
      px-3 py-1 
      text-xs 
      font-semibold 
      rounded-full 
      uppercase 
      tracking-widest 
      shadow-lg 
      ring-1
      transition-colors 
      duration-300
      ${pillClasses}
    `}
  >
    {text}
  </span>
</div>
                    
                  </div>
                </div>
              </div>

              {/* Transaction Lines Section - Approve Only */}
            
                <div className="bg-gray-700/70 border border-cyan-500/30 rounded-xl shadow-lg overflow-hidden">
                  {/* Table Header */}
                  <div className="grid grid-cols-10 gap-2 p-3 bg-cyan-900 text-cyan-200 font-extrabold uppercase text-xs sm:text-sm md:text-base">
                    <div className="col-span-4 text-left">Product / Description</div>
                    <div className="col-span-2 text-center">Unit Price</div>
                    <div className="col-span-1 text-center">Qty</div>
                    <div className="col-span-1 text-center">Disc %</div>
                    <div className="col-span-2 text-right">Net Total</div>
                  </div>
                  
                  {/* Table Body - Map through lines for viewing */}
                  <div className="p-1">
                    {/* Assuming the `fields` array now holds the read-only data */}
                    {quotation?.transactionLines?.length > 0 ? (
                      quotation?.transactionLines.map((field, index) => {
                        // Watch for line data to display
                        // const line = watch(`transactionLines.${index}`);
                        
                   

                        return (
                          <div key={field.id} className="grid grid-cols-10 items-center px-3 py-2 border-b border-gray-600 hover:bg-gray-700 transition-colors duration-200 text-sm">
                            {/* Product / Description */}
                            <div className="col-span-4 text-left text-white font-medium pr-2">
                              {field.description || 'N/A'}
                            </div>
                            {/* Price */}
                          

                            <div className="col-span-2 text-center text-cyan-300">
                              {formatCurrency(field.unitPriceExclusive)}
                            </div>
                            {/* Quantity */}
                            <div className="col-span-1 text-center text-white">
                              {field?.quantity}
                            </div>
                            {/* Discount */}
                            <div className="col-span-1 text-center text-red-400">
                              {field?.discount_percentage}%
                            </div>
                            {/* Total (Net of Tax) */}
                            <div className="col-span-2 text-right text-white font-bold">
                              {formatCurrency(field.lineDiscountedPriceExclusive)}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="p-6 text-center text-cyan-400/70 text-base">No transaction lines on this quotation.</p>
                    )}
                  </div>
                </div>
              


              {/* Invoice Summary - Approve Only */}
            
                <div className="bg-gray-700/70 border border-cyan-500/30 p-4 rounded-xl shadow-lg">
                  <div className="font-extrabold text-xl sm:text-2xl text-cyan-200 mb-3 border-b border-cyan-500/50 pb-2">Summary</div>
                  <div className="space-y-2">
                    {/* Subtotal */}
                    <div className="flex justify-between items-center py-1 border-b border-gray-600">
                      <div className="text-base text-cyan-300">Subtotal (Exc Tax):</div>
                      <div className="text-base font-semibold text-white">{formatCurrency(quotation.totalDiscountedPriceExclusive)}</div>
                    </div>
                    
                    {/* Tax */}
                    <div className="flex justify-between items-center py-1 border-b border-gray-600">
                      <div className="text-base text-cyan-300">Total Tax:</div>
                      <div className="text-base font-semibold text-white">{formatCurrency(quotation.totalTaxAfterDiscounted)}</div>
                    </div>
                  </div>
                  {/* Grand Total */}
                  <div className="flex justify-between items-center pt-4 font-extrabold text-xl text-cyan-100">
                    <div className="text-lg">Grand Total (Incl. Tax):</div>
                    <div className="text-lg">{formatCurrency(quotation.totalDiscountedPriceInclusive)}</div>
                  </div>
                  <div className="flex justify-between items-center pt-4 font-extrabold text-sm text-cyan-100">
                    <div className="text-sm">Total Discount:</div>
                    <div className="text-sm text-cyan-400">{formatCurrency(quotation.totalDiscountInclusive)}</div>
                  </div>
                </div>
              
            </div>
          )}
          
          {/* Footer - Only a Back button is needed */}
          <div className="flex justify-center mt-8">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-3 rounded-xl font-bold text-gray-900 bg-cyan-400 hover:bg-cyan-300 transition-all duration-300 shadow-xl tracking-wider uppercase"
            >
              Back to List
            </button>
          </div>

        </div>
      </div>
    </Layout>
  );
};

export default ApproveQuotation;